/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { ButtonSecondary, ButtonTertiary, Input, Label } from '@americanexpress/dls-react';
import { CardNameEditViewModel } from 'src/types/view-models/card-name-edit.view.model';
import LiteralsService from '../../services/literals/LiteralsService';
import UtilsService from '../../services/utils.service';
import { CardModel } from 'src/types/card.model';

// styles
import styles from './CardNameEdit.module.scss';
import Selectors from 'src/utils/selectors';

export default class CardNameEdit extends Component<CardNameEditViewModel> {
    public override state = {
        // use the nickname if the user has set one, otherwise pull the default card description as the name
        tempName:
            this.props.card.nickname || LiteralsService.getLiteral(`Goals.${this.props.card.description.toLowerCase()}`)
    };

    public override render(): ReactComponentElement<any> {
        return (
            <div className={styles.editContainer}>
                <div>
                    <Label htmlFor="editNameInput">Edit Life Event Name</Label>
                    <Input
                        id="editNameInput"
                        value={this.state.tempName}
                        onChange={(e: any) => this.handleChange(e.target.value)}
                        onKeyUp={async (e: any) => await this.handleKeyUp(e)}
                    />
                </div>
                <div className={styles.editButtons} data-cy={Selectors.PlanAhead.SAVE_NAME_BUTTON}>
                    <ButtonSecondary size="sm" onClick={this.handleSave.bind(this)}>
                        Save
                    </ButtonSecondary>
                    <ButtonTertiary size="sm" onClick={this.props.toggleEditingName}>
                        Cancel
                    </ButtonTertiary>
                </div>
            </div>
        );
    }

    private handleChange(value: string): void {
        this.setState({
            tempName: UtilsService.capitalizeFirstLetter(value)
        });
    }

    private async handleKeyUp(event: any): Promise<void> {
        if (event.keyCode === 13) {
            await this.handleSave();
        }
    }

    private async handleSave(): Promise<void> {
        this.props.handleChangeCard(this.props.card, this.state.tempName, 'nickname');
        this.props.toggleEditingName();

        const cardCopy: CardModel = { ...this.props.card, nickname: this.state.tempName };
        if (this.props.handleUpdateCard) await this.props.handleUpdateCard(cardCopy);
    }
}
